/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Import_DescriptionInputs */



/**
* | output |
* | --- |
* | "Import results from a filled-in legacy Archon spreadsheet (.xlsx). All players must have valid VEKN IDs." |
*
* @param {Archon_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_import_description = /** @type {((inputs?: Archon_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Import_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importez les résultats depuis un tableur Archon historique (.xlsx). Tous les joueurs doivent avoir des VEKN IDs valides.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importe resultados desde una hoja de cálculo Archon histórica (.xlsx). Todos los jugadores deben tener VEKN IDs válidos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importe resultados de uma planilha Archon legada (.xlsx). Todos os jogadores devem ter VEKN IDs válidos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa i risultati da un foglio di calcolo Archon storico (.xlsx). Tutti i giocatori devono avere VEKN ID validi.")
	return /** @type {LocalizedString} */ ("Import results from a filled-in legacy Archon spreadsheet (.xlsx). All players must have valid VEKN IDs.")
});